<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="车辆信息" name="1">
      <template #title>
        <h3>车辆信息</h3>
      </template>
      <el-empty v-if="!orderCar" description="暂无数据"/>
      <div v-else class="order-info">
        <div class="info-item">VIN码: {{ orderCar.vin }}</div>
        <div class="info-item">品牌: {{ orderCar.makeName }}</div>
        <div class="info-item">车系: {{ orderCar.modelName }}</div>
        <div class="info-item">车款年代: {{ orderCar.styleYear }}</div>
        <div class="info-item">车型: {{ orderCar.styleName }}</div>
        <div class="info-item">变速箱: {{ orderCar.transmissionType }}</div>
        <div class="info-item">发动机排量: {{ orderCar.exhaust }}</div>
        <div class="info-item">燃料类型: {{ orderCar.fuel }}</div>
        <div class="info-item">行使里程: {{ orderCar.mileage }}</div>
        <div class="info-item">首次上牌日期: {{ orderCar.recordDate }}</div>
        <div class="info-item">发动机编号: {{ orderCar.engineNum }}</div>
        <div class="info-item">车辆颜色: {{ orderCar.color }}</div>
        <div class="info-item">新车参考价: {{ orderCar.manufacturerPrice }}</div>
        <div class="info-item">参考价: {{ orderCar.referencePrice }}</div>
        <div class="info-item">车牌号: {{ orderCar.carLicense }}</div>
        <div class="info-item">过户次数: {{ orderCar.transferCount }}</div>
        <div class="info-item">评估结果: <a :href="orderCar.result"
                                            target="_blank">{{ getFileName(orderCar.result) }}</a></div>
        <div class="info-item">抵押城市: {{ orderCar.city }}</div>
      </div>
    </el-collapse-item>
    <el-collapse-item title="车辆评估" name="2">
      <template #title>
        <h3>车辆评估</h3>
      </template>
      <el-empty v-if="!orderCarAssessment" description="暂无数据"/>
      <div v-else class="order-info">
        <div class="info-item">所在省市: {{ orderCarAssessment.provinceName }}</div>
        <div class="info-item">状态: {{ $dict.nameOf('car_assessment_status', orderCarAssessment.status) }}</div>
        <div class="info-item">结果描述: {{ orderCarAssessment.message }}</div>
        <div class="info-item">评估结果: <a :href="orderCarAssessment.resultPdf"
                                            target="_blank">{{ getFileName(orderCarAssessment.resultPdf) }}</a></div>
        <!--         <div>评估结果: {{ orderCarAssessment.resultTxt }}</div>-->
        <!--          <div v-if="orderCarAssessment.resultPdf" style="margin-left: 10px; width: 100%">-->
        <!--            <p>评估结果: 评估结果文件.pdf </p>-->
        <!--            <el-button type="primary" size="mini" @click="previewPDF(orderCarAssessment.resultPdf)">预览</el-button>-->
        <!--            <el-button type="success" size="mini" @click="downloadPDF(orderCarAssessment.resultPdf)">下载</el-button>-->
        <!--          </div>-->
        <div style="margin-left: 10px; width: 100%">
          <div>图片列表:</div>
          <div>
            <el-image v-for="(image, index) in imageList" :key="index"
                      style="max-width: 200px; max-height: 200px; margin: 5px"
                      :src="image.ossImageUrl" fit="scale-down" :preview-src-list="[image.ossImageUrl]"></el-image>
          </div>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import {hasPer} from "@/utils/common";

export default {
  name: "OrderCar",
  components: {},
  props: {
    orderDetail: {
      type: Object,
      required: true
    }
  },
  computed: {
    orderCar() {
      return this.orderDetail.orderCar;
    },
    orderCarAssessment() {
      return this.orderDetail.orderCarAssessment;
    },
    imageList() {
      return this.orderCarAssessment && this.orderCarAssessment.imageList ? JSON.parse(this.orderCarAssessment.imageList) : [];
    }
  },
  data() {
    return {
      activeNames: ['1', '2'],
      // imageList: []
    };
  },
  mounted() {
    this.dealImage();
  },
  methods: {
    hasPer,
    dealImage() {
      // 处理图片的逻辑
      // return this.imageList = this.orderCarAssessment ? JSON.parse(this.orderCarAssessment.imageList) : [];
    },
    previewPDF(pdfUrl) {
      // 预览PDF的逻辑
      window.open(pdfUrl, '_blank');
    },
    downloadPDF(pdfUrl) {
      // 下载PDF的逻辑
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = '评估结果.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getFileName(pdfUrl) {
      if (!pdfUrl) {
        return '';
      }
      return pdfUrl.split('/').pop();
    }
  }
}
</script>

<style scoped>
.order-info {
  display: flex;
  flex-wrap: wrap;
}

.info-item {
  flex-basis: calc(33.333% - 20px);
  box-sizing: border-box;
  min-width: 200px;
  margin: 10px;
}
</style>
